import {
  BankDetailsSection,
  type BankDetailsConfig,
} from "@project/user/components/bank-details-section";

import upiQrImg from "@project/assets/Gaushala/vrindavan-upi-qr.png";

const GAUSHALA_BANK_DETAILS: BankDetailsConfig = {
  orgName: "Vrindavan Gir Gaushala",
  bankName: "Kotak Mahindra Bank",
  branch: "Maninagar",
  accountNumber: "9312660230",
  accountName: "Vrindavan Gir Gaushala",
  ifsc: "KKBK0002584",
  upiId: "0792584A0134831.bqr@kotak",
  upiPayeeName: "VRINDAVAN GIR GAUSHALA",
  qrImage: upiQrImg,
  qrDownloadName: "vrindavan-gir-gaushala-upi-qr.png",
};

export function GaushalaBankDetails() {
  return (
    <BankDetailsSection
      id="gaushala-bank-details"
      details={GAUSHALA_BANK_DETAILS}
    />
  );
}
